import { render, staticRenderFns } from "./hand-thumbs-down.vue?vue&type=template&id=c944b2ce&"
import script from "./hand-thumbs-down.vue?vue&type=script&lang=js&"
export * from "./hand-thumbs-down.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c944b2ce')) {
      api.createRecord('c944b2ce', component.options)
    } else {
      api.reload('c944b2ce', component.options)
    }
    module.hot.accept("./hand-thumbs-down.vue?vue&type=template&id=c944b2ce&", function () {
      api.rerender('c944b2ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/hand-thumbs-down.vue"
export default component.exports